import { calendarKeys } from 'hooks/queries/calendar/calendarKeys'
import { AlmanacFileCalendarItem } from 'hooks/queries/calendar/types'
import { useQueryClient } from 'react-query'

export const useMarkFileAsViewed = () => {
  const queryClient = useQueryClient()

  const markFileAsViewed = (almanacFileKey?: string | null) => {
    if (!almanacFileKey) return

    const queries = queryClient.getQueriesData<AlmanacFileCalendarItem[]>(calendarKeys.all)

    queries.forEach(([queryKey, oldData]) => {
      if (!oldData || !Array.isArray(oldData)) return

      const newData = oldData.map((item) => {
        if (item.key === almanacFileKey) {
          return {
            ...item,
            viewed_at: new Date().toISOString(),
          }
        }
        return item
      })

      queryClient.setQueryData(queryKey, newData)
    })
  }

  return { markFileAsViewed }
}
